module.exports = __webpack_public_path__ + "static/media/ana-luiza-machado-silveira.2760bf56.jpg";